import { render, staticRenderFns } from "./BsContainer.vue?vue&type=template&id=6fd98487&"
import script from "./BsContainer.vue?vue&type=script&lang=js&"
export * from "./BsContainer.vue?vue&type=script&lang=js&"
import style0 from "./BsContainer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports